import Promise from 'core-js/es6/promise'
import $ from "cash-dom"
import { initModules } from './index.js'

class LayerLinkModule {

    static name = 'layerlink'

    static cache = {}

    constructor(node) {

        $(node).on('click', this.handleLink)

        this.$node = $(node)
    }

    handleLink = (e) => {

        e.preventDefault()
        e.stopPropagation()

        const $node = this.$node
        const url = $node.attr('href')
        const { $inner, cache, open } = this.constructor

        $node.addClass('loader')
        
        return new Promise((resolve, reject) => {
            if(cache[url]) {
                resolve(cache[url]) 
            } else {
                resolve(window.fetch(url, {
                    headers: {
                        "X-Requested-With": "XMLHttpRequest"
                    }
                })
                .then(res => res.text())
                .then(res => {
                    cache[url] = res
                    return res
                }))
            }
        })
        .then(res => {

            $node.removeClass('loader')

            const part = $(res).children()

            //scroll to top
            $inner
                .html('')
                .append(part)
                [0].scrollTop = 0

            initModules($inner)
            open()
        })
    }


    static open = () => {

        $('body').addClass('unscrollable')
        this.$layer.removeClass('hidden')
    }


    static close = () => {

        const { $layer, $inner } = this

        if($layer.hasClass('hidden')) return;
        
        $('body').removeClass('unscrollable')

        //remove content
        $layer.addClass('hidden').on('transitionend', (e) => {
            $inner.html('')
            $layer.off('transitionend')
        })
    }

}

$(() => {

    LayerLinkModule.$layer = $(`<div class="layer hidden"><div class="layer__close"></div></div>`)
        .on('click', '.layer__close', LayerLinkModule.close)
        .appendTo( $('body') )

    LayerLinkModule.$inner = $('<div class="layer__inner"></div>')
        .appendTo( LayerLinkModule.$layer )

})



export default LayerLinkModule